import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl, claimTypes } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { ClientListHead } from '../../_dashboard/clients';
import { useConstantsContext } from '../../../context/constants_context';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'provn', label: 'Member', alignRight: false },
  { id: 'department', label: 'Service', alignRight: false },
  { id: 'tarrifCode', label: 'Tarif Code', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  // { id: 'service', label: 'Service', alignRight: false },
  { id: 'count', label: 'Count', alignRight: false },
  { id: 'amount', label: 'Total Claimed', alignRight: true },
  { id: 'amountPd', label: 'Total Paid', alignRight: true },
  { id: 'stat', label: 'Status', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ProviderClaimsSummary() {
  const { payCycles } = useConstantsContext();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(m);
  const [endDate, setEndDate] = useState(m);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [namas, setNamas] = useState('0');
  const [docType, setDocType] = useState('pdf');
  const [claimState, setClaimState] = useState(0);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });
  const filename = `ClaimsByType_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // getClaimsByProviderSum();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const getClaimsByProviderSum = () => {
    setLoading(true);

    const fromDate = moment(begDate).format('YYYY-MM-DD');
    const toDate = moment(endDate).format('YYYY-MM-DD');

    const url = `${baseUrl}/api/claims/GetClaimsByPaymentDate?from=${fromDate}&to=${toDate}&dateType=0&status=0&type=${claimState}`;

    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned Provider getClaimsByProviderSum Summary list', result);
          setDataList(result.result ?? []); // fallback to empty array
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in getClaimsByProviderSum!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/get/ClaimsProvider/${docType}/${moment(begDate).format(
        'YYYY-MM-DD'
      )}/${moment(endDate).format('YYYY-MM-DD')}/${namas}/1/0/0/${claimState}`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Claims Summary!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={3}>
          <Typography component="span" variant="h4" gutterBottom>
            Claims By Type...
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel id="claimStatelb">Claim Status</InputLabel>
            <Select
              fullWidth
              labelId="claimStateLbl"
              id="claimState"
              size="small"
              value={claimState}
              onChange={(e) => {
                setClaimState(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {claimTypes.map((item) => (
                <MenuItem key={item.refId} value={item.refId}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              size="small"
              value={docType}
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              value={begDate}
              size="small"
              onChange={(e) => {
                setBegDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="To Date"
              value={endDate}
              size="small"
              onChange={(e) => {
                setEndDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getClaimsByProviderSum()}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Export
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      principalMember,
                      department,
                      tarif_code,
                      service,
                      tariff_desc,
                      totalVisits,
                      totalClaimed,
                      totalPaid,
                      claim_Status
                    } = row;
                    const isItemSelected = selected.indexOf(department) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={department}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{principalMember}</TableCell>
                        <TableCell align="left">{service}</TableCell>
                        <TableCell align="right">{tarif_code}</TableCell>
                        <TableCell align="left">{tariff_desc}</TableCell>
                        {/* <TableCell align="left">{service}</TableCell> */}
                        <TableCell align="left">{totalVisits}</TableCell>
                        <TableCell align="right">{totalClaimed.toFixed(2)}</TableCell>
                        <TableCell align="right">{totalPaid.toFixed(2)}</TableCell>
                        <TableCell align="left">{claim_Status}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
